<template>
  <div class="order">
    <div>
      <div class="my_tab">
        <ul class="tab_ul_box">
          <li :class="{ active: item.key == iskey }" @click="checkTab(item.key)" v-for="item in tab" :key="item.key">{{
            item.name }}</li>
        </ul>
      </div>
      <!-- 搜索 -->
      <div class="search_wrap flex">
        <div class="search">
          <qdd-icon class="iconxiazai17" color="#999" size=".5rem"></qdd-icon>
          <input type="text" @click="jump" />
        </div>
        <span class="gray">取消</span>
      </div>
      <!-- 列表 -->

      <van-list v-model="loading" :finished="finished" :immediate-check="false" @load="onLoad" :offset="20">
        <ul class="goodsList">
          <li v-for="(item, index) in orderList" :key="index">
            <!-- 订单状态 -->
            <div class="status flex_b">
              <div>
                <qdd-icon class="iconjishi" color="#333" size=".5rem"></qdd-icon>
                <span class="ml10">
                  {{ item.add_time_format }}
                  <i style="color: #FF0000;font-size: 0.48rem;font-style: normal;"
                    v-if="item.is_exchange_order == 1">(换货)</i>
                </span>
              </div>
              <div class="red">{{ item.status_txt }}</div>
              <!-- <div class="red" v-if="item.status == 11">待付款</div>
              <div class="red" v-show="item.status == 20">待发货</div>
              <div class="red" v-show="item.status == 30">待收货</div>
              <div class="red" v-show="item.status == 40 && item.goods_type == 2">待确认</div>
              <div
                class="red"
                v-show="
                  (item.goods_type == 2 && item.status == 41) ||
                    (item.goods_type != 2 &&
                      (item.status == 41 || item.status == 40))
                "
              >已完成</div>
              <div class="red" v-show="item.status == 0">已取消</div>
              <div class="red" v-show="item.status == 34">已关闭</div>
              <div class="red" v-show="item.status == 10">已提交</div> -->
            </div>
            <!-- 商品 -->
            <div class="goods flex" @click="goDetail(item.id, item.xhq_id)">
              <img :src="item.goods_image" alt />
              <div class="right_con">
                <p class="t_line2 goods_name">{{ item.goods_name }}</p>
                <div class="gray" v-show="item.specification != ''">规格：{{ item.specification }}</div>
                <div class="flex_b">
                  <div class="jifen flex">
                    <span class="red">{{ item.price_format }}</span>
                  </div>
                  <div class="gray">X{{ item.quantity }}</div>
                </div>
              </div>
            </div>
            <!-- 合计 -->
            <div class="total">
              合计
              <span class="red">{{ item.order_total_amount_format }}</span>
              (含运费{{ item.shipping_fee_format }})
            </div>

            <!-- 底部按钮 -->
            <div class="footer" v-if="item.status == '30' || item.status == '40' || item.status == '20'">
              <div v-if="item.status == '11'">
                <div class="toPay">立即支付</div>
                <div class="cancel">取消订单</div>
              </div>
              <!--		0222 暂时隐藏确认收货和支付功能一起上	-->

              <div class="toPay" v-if="item.status == '30' && item.goods_type == 1" @click="
            goAffirm(item.id, item.goods_type)
            ">确认收货</div>

              <div class="toPay" v-if="item.goods_type == 2 && item.status == '40'"
                @click="goAffirm(item.id, item.goods_type)">确认兑换</div>

              <div v-if="item.goods_type == 1 && item.is_show_logistics == 1" class="seewuliu"
                @click="goSeeWuLiu(item.xhq_id, item.logisticsMore,)">查看物流</div>
            </div>
          </li>
        </ul>
        <p class="null_title_x" v-show="isShowTitle && orderList.length">没有更多了</p>
      </van-list>
      <div class="nodata" v-show="!orderList.length">
        <img :src="imgPath + 'wudingda.png'" alt />
        <p>还没有相关订单</p>
      </div>
    </div>
    <mloading v-if="showLoading"></mloading>
  </div>
</template>
<!-- 订单状态 10已提交11待付款20待发货30已发货31退款申请32退款申请拒绝33退款申请完成40已完成,41已评价,0已取消 -->
<script>
import icon from '@/components/iconfont.vue'
import { Dialog, Toast } from 'vant'
import { sendRequest } from '@/assets/public'
import mloading from '@/components/loading.vue'

export default {
  components: {
    'qdd-icon': icon,
    mloading,
  },
  data() {
    return {
      tab: [
        { name: '全部', key: '0' },
        { name: '待发货', key: '20' },
        { name: '待收货', key: '30' },
        { name: '待确认', key: '100' },
        { name: '已完成', key: '40' },
      ],
      iskey: '0',
      page: 1,
      goods_type: 1, // 1商城兑换 2店铺兑换
      nullTit: false,
      orderList: [],
      loading: false,
      finished: false,
      isShowTitle: false,
      showLoading: false,
    }
  },
  created() {
    //创建组件时，加载第1页数据
    console.log(this.$route.query.type)
    this.iskey = this.$route.query.type

    this.getroadList()
    window.scrollTo(0, 0)
  },
  mounted() {
    console.log(localStorage.getItem('store_id'))
  },
  methods: {
    async getroadList() {
      this.isShowTitle = false
      let checkId = this.iskey == 100 ? '40' : this.iskey
      let type = this.iskey == 100 ? '2' : this.iskey == 40 ? '' : '1'
      type = this.iskey == 0 ? 0 : type
      let res = await sendRequest('order/list', {
        status: checkId,
        page: this.page,
        limit: 6,
        goods_type: type,
      })
      let tlist = res.content.list || []

      if (res.content.list.length < 5) {
        this.isShowTitle = true
      }
      this.orderList = this.orderList.concat(tlist)
      this.loading = false
      this.finished = tlist.length == 0
    },
    //滚动加载时触发，list组件定义的方法
    onLoad() {
      this.page++
      this.getroadList()
    },

    checkTab(key) {
      this.iskey = key
      // this.$router.replace({ path: '/order', query: { type: key } })
      this.page = 1
      window.scrollTo(0, 0)
      this.orderList = []
      this.getroadList()
    },

    goDetail(id, xh_id) {
      this.$router.push({
        name: 'orderDetails',
        query: { oderId: id, xh_id: xh_id },
      })
    },
    jump() {
      this.$router.push({ name: 'orderSearch' })
    },
    // 查看物流
    goSeeWuLiu(id, logisticsMore) {
      console.log(id, logisticsMore)
      if (logisticsMore == 1) {
        this.$router.push({
          name: 'wuliuList',
          query: { xh_id: id ? id : '' },
        })
      } else {
        this.$router.push({
          name: 'wuliu_info',
          query: { xh_id: id ? id : '' },
        })
      }
      // this.$router.push({
      //   name: 'wuliu_info',
      //   query: { xh_id: id ? id : '' },
      // })
    },
    goAffirm(id, goods_type) {
      let _this = this
      Dialog.confirm({
        message: '您是否确认收货？',
        confirmButtonText: '确定',
        confirmButtonColor: '#FD3E3E',
      })
        .then(() => {
          _this.getHuo(id, goods_type)
          // on confirm
        })
        .catch(() => {
          // on cancel
        })
    },
    async getHuo(id, goods_type) {
      let _this = this
      this.showLoading = true
      let { content, status, msg } = await sendRequest('order/confirm', {
        order_id: id,
        is_sure: 2,
      })
      this.showLoading = false

      if (status == '200') {
        if (goods_type == 2) {
          Toast('确认自提成功')
          this.checkTab(0)
        } else {
          Toast('确认收货成功')
          this.checkTab(0)
        }
      } else {
        Toast(msg)
      }
    },
  },
}
</script>
<style scoped>
.seewuliu {
  color: #999999;
  border: 1px solid #999999;
}

.null_title_x {
  text-align: center;
  font-size: 0.56rem;
  color: #666;
  margin-bottom: 0.2rem;
}

.ml10 {
  margin-left: 0.2rem;
}

.my_tab {
  width: 100%;
  background: #fff;
  height: 1.88rem;
  line-height: 1.88rem;
  position: fixed;
  top: 0;
}

.my_tab .tab_ul_box {
  display: flex;
  justify-content: space-around;
  color: #999999;
  font-size: 0.56rem;
  height: 1.76rem;
}

.my_tab .tab_ul_box li {
  width: 1.72rem;
  text-align: center;
  border-bottom: 0.08rem solid transparent;
}

.my_tab .tab_ul_box li.active {
  color: #333333;
  border-bottom: 0.08rem solid #fd3e3e;
}

.gray {
  font-size: 0.48rem;
  color: #999;
}

.goods {
  background: #ffffff;
  padding: 0.4rem 0.8rem;
}

.goods img {
  width: 4rem;
  height: 4rem;
}

.right_con {
  width: 8.66rem;
  margin-left: 0.8rem;
  text-align: left;
}

.goods_name {
  font-size: 0.6rem;
  font-weight: 500;
  margin-bottom: 0.4rem;
}

.right_con .flex_b {
  margin-top: 0.6rem;
}

.right_con .flex_b .gray {
  line-height: 0.86rem;
}

.jifen .red {
  font-size: 0.72rem;
  font-weight: bold;
}

.badge {
  font-size: 0.4rem;
  color: #fd3e3e;
  border: 1px solid #fd3e3e;
  border-radius: 0.4rem;
  padding: 0.05rem 0.24rem;
  display: inline-block;
  margin-left: 0.12rem;
}

.footer {
  background: #ffffff;
  padding: 0.4rem 0.8rem;
  overflow: hidden;
}

.footer div {
  width: 3.8rem;
  height: 1.2rem;
  line-height: 1.2rem;
  text-align: center;
  font-size: 0.56rem;
  float: right;
  margin-left: 0.4rem;
  border-radius: 0.6rem;
}

.toPay {
  background: #fd3e3e;
  color: #fff;
  border: 1px solid #fd3e3e;
}

.cancel {
  color: #999999;
  border: 1px solid #999;
}

.goodsList {
  margin-top: 4rem;
}

.goodsList li {
  background: #fff;
  margin-bottom: 0.4rem;
}

.total {
  text-align: right;
  font-size: 0.48rem;
  padding: 0.4rem 0;
  border-top: 1px solid #dddddd;
  margin: 0 0.8rem;
}

.total span {
  font-size: 0.72rem;
  font-weight: bold;
  margin: 0 0.12rem;
}

.status {
  font-size: 0.56rem;
  margin: 0 0.8rem;
  border-bottom: 1px solid #dddddd;
  height: 1.76rem;
  line-height: 1.76rem;
}

.search_wrap {
  position: fixed;
  top: 44px;
  left: 0;
  right: 0;
  background: #f6f5f8;
  padding: 0.4rem 0.8rem;
  font-size: 0.56rem;
  height: 1.2rem;
  line-height: 1.2rem;
}

.search {
  width: 11.6rem;
  height: 1.2rem;
  background: #fff;
  margin-right: 0.4rem;
  padding-left: 0.4rem;
}

.search input {
  width: 9.4rem;
  height: 0.9rem;
  margin-left: 0.2rem;
  border: none;
}

.nodata {
  font-size: 0.6rem;
  color: #999;
  text-align: center;
}

.nodata img {
  width: 6.88rem;
  height: 5.56rem;
  display: block;
  margin: 2.76rem auto 0.8rem;
}
</style>